export default __webpack_public_path__ + "static/media/whitesoul7.9daadae8.jpg";